import { Lang } from 'Roblox';
import angular from 'angular';

let subscription = angular
    .module("subscription", ["robloxApp", "modal", "premium"])
    .config(['$injector',
        function ($injector) {
            var languageResourceProvider = $injector.get("languageResourceProvider");
            if (Lang.PremiumResources) {
                languageResourceProvider.setLanguageKeysFromFile(Lang.PremiumResources);
            }
            if (Lang["CommonUI.Features"]) {
                languageResourceProvider.setLanguageKeysFromFile(Lang["CommonUI.Features"]);
            }
        }]);

export default subscription;